import React, { useEffect } from 'react';
import { Button, Col, Row, Table } from 'reactstrap';
import { isFunction } from 'lodash';
import { connect } from 'react-redux';
import User from './User';
import { deleteUser, loadUsers, selectUser } from '../../actions/users';

export const UserList = ({ onMount, users = [], select, selectedUser, remove, isAdmin }) => {
  useEffect(() => {
    if (isFunction(onMount)) onMount();
  }, []);

  if (!isAdmin) return null;

  const renderList = () => {
    return (
      <div className='mt-3'>
        <Table hover>
          <thead>
            <tr>
              <th className='font-weight-bold'>#</th>
              <th>Username</th>
              <th>Full name</th>
              <th>Role</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {users?.map((u, i) => (
              <tr key={u.seq}>
                <td className='font-weight-bold'>{i + 1}</td>
                <td>
                  <span className='btn-link' onClick={() => select(u)}>
                    {u.username}
                  </span>
                </td>
                <td>{u.name}</td>
                <td>{u.userRole}</td>
                <td>
                  <Button color='danger' onClick={() => remove(u)}>
                    Xóa
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  return (
    <div className='mx-5 mt-3'>
      <Row>
        <Col lg={6}>
          <div className='h3 text-primary text-uppercase'>Danh sách người dùng nội bộ</div>
          <Button color='primary' onClick={() => select({})} className='text-uppercase'>
            Tạo
          </Button>

          {users?.length === 0 ? null : renderList()}
        </Col>
        {!selectedUser ? null : (
          <Col lg={6}>
            <User />
          </Col>
        )}
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  const users = state?.user?.all || [];
  const selectedUser = state?.user?.selected;
  const isAdmin = state?.auth?.authorities?.map((e) => e.authority).includes('ROLE_ADMIN');
  return { users, selectedUser, isAdmin };
};

const mapDispatchToProps = { onMount: loadUsers, select: selectUser, remove: deleteUser };

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
